import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EmployeeLoginRequestBody, EmployeeLoginResponse } from '../Models/employee-login';
import { SessionvalidateService } from './sessionvalidate.service';
import { Router } from '@angular/router';
import { ResultStatus } from '../Models/common';
import { EmployeeAndUserData, EmployeeData, UserData } from '../Models/employee-and-user-data';

@Injectable({
  providedIn: 'root',
})
export class EmployeeloginService {
  OBPortalSvcURL = '';
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private loginCache = new Map<string, Observable<EmployeeLoginResponse>>();

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient,
    private router: Router,
    private sessionValidateService: SessionvalidateService) {
      this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    }

  public GetEmployeeLogin(EmployeeNo?: any, LastName?: string): Observable<EmployeeLoginResponse> {
    const key = `${EmployeeNo}-${LastName}`;
    if (!this.loginCache.has(key)) {
      const employeeLoginInfo = new EmployeeLoginRequestBody(EmployeeNo, LastName);
      this.loginCache.set(key,
        this.httpClient.post<EmployeeLoginResponse>(
          `${this.OBPortalSvcURL}GetEmployeeLogin`, employeeLoginInfo, { headers: this.headers }
        ).pipe(shareReplay(1))
      );
    }
    return this.loginCache.get(key)!;
  }

  public clearLoginCache(): void {
    this.loginCache.clear();
  }

  /**Returning something after navigating doesnt really work.
   * We do it in this case in order to easily access the returned object
   */
  public GetEmployeeAndUserData(): EmployeeAndUserData {
    const result = new EmployeeAndUserData({} as EmployeeData, {} as UserData);
    result.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}') as EmployeeData;

    // if employee info found from localStorage, get their login info via backend and check it
    if (result.employeeData?.EmployeeNo != undefined) {
      this.GetEmployeeLogin(result.employeeData?.EmployeeNo, result.employeeData?.LastName).subscribe((data) => { 
        result.userData = this.checkLogin(data);
      });
    }
    else {
      const validsession = this.sessionValidateService.validate();
      // if session hasn't expired yet, get userdata from local storage, otherwise route to normal login
      if (validsession) {
        result.userData = JSON.parse(localStorage.getItem('userinfo') || '{}') as UserData;
      }
      else
      {
        this.router.navigate(['/login']);
      }
    }
    return result;
  }

  private checkLogin(employeeLoginResponse: EmployeeLoginResponse): UserData {
    let result = {} as UserData;
    // If employee login was unsuccessful, route back to admin login
    if (employeeLoginResponse.GetEmployeeLogin.Result.Status != ResultStatus.Accepted) {
      this.router.navigate(['/adminlogin']);
    }
    else {
      const isValidSession = this.sessionValidateService.validate();
      // if session hasn't expired yet, get userdata from local storage, otherwise route to ship selection
      if (isValidSession) {
        result = JSON.parse(localStorage.getItem('userinfo') || '{}') as UserData;
      } 
      else {
        this.router.navigate(['/shipselect']);
      }
    }
    return result;
  }
}
